import type { RouteRecordRaw } from 'vue-router';

export const settingsRoutes = [
  {
    path: 'settings',
    component: () => import('./SettingsPage.vue'),
    children: [
      {
        path: '',
        name: 'settings',
        component: () => import('./components/SettingsUserDetails.vue'),
      },
      {
        path: 'company',
        name: 'settings-company-details',
        component: () => import('./components/SettingsCompanyDetails.vue'),
      },
      {
        path: 'notifications',
        name: 'settings-notifications',
        component: () => import('./components/SettingsNotifications.vue'),
      },
      {
        path: 'preferences',
        name: 'settings-preferences',
        component: () => import('./components/SettingsPreferences.vue'),
      },
      {
        path: 'login-activity',
        name: 'settings-login-activity',
        component: () => import('./components/SettingsLoginActivity.vue'),
      },
      {
        path: 'account-safety',
        name: 'settings-account-safety',
        component: () => import('./components/SettingsAccountSafety.vue'),
      },
      {
        path: 'transfer-limits',
        name: 'settings-transfer-limits',
        component: () => import('./components/SettingsTransferLimits.vue'),
      },
      {
        path: 'user-control',
        name: 'settings-user-control',
        component: () => import('./components/SettingsUserControl.vue'),
      },
    ],
    meta: {
      title: 'Settings',
    },
  },
] as const satisfies readonly RouteRecordRaw[];
